/* CTR Creatine — benefits CTA (sections/ctr-creatine-benefits.liquid)
   [data-ctr-scroll-buybox] links scroll smoothly to the product buy box, below the sticky header. */
(function () {
  if (window.ctrScrollBuyboxBound) return;
  window.ctrScrollBuyboxBound = true;

  function stickyHeaderHeight() {
    var header = document.querySelector('.site-header');
    if (!header) return 0;
    var wrapper = header.closest('[data-section-type="header"]') || header;
    var position = getComputedStyle(wrapper).position;
    var stuck = position === 'fixed' || position === 'sticky' || header.classList.contains('site-header--stuck');
    return stuck ? header.offsetHeight : 0;
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-ctr-scroll-buybox]');
    if (!link) return;
    var target = document.querySelector('[data-section-type="product-template"]');
    if (!target) return;
    event.preventDefault();
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var top = target.getBoundingClientRect().top + window.pageYOffset - stickyHeaderHeight() - 12;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
  });
})();
